import { Button, Grid, Typography } from "@mui/material"
import OneModal from "../../OneModal/OneModal"
import OneTextArea from "../../OneTextArea/OneTextArea"

const ModalObservacao = ({ open, setOpen, onClickButton, texto, onChangeText }) => {
    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={'Manter Aberto'}
            height="60%"
            width="60%"
        >
            <Grid container >
                <Grid sx={{ display: "flex", alignItems: 'flex-end', justifyContent: "space-between", width: '100%', height: '10%' }}>
                    <Typography>Observação: </Typography>
                    {
                        texto.length < 5
                            ? <Typography sx={{ color: 'red' }}>Min. de 5 caracteres </Typography>
                            : ''
                    }
                </Grid>
                <Grid width={'100%'} height={'80%'} marginTop={1}>
                    <Grid width={'100%'} height={'70%'}>
                        <OneTextArea
                            onChange={onChangeText}
                            defaultValue={texto}
                            contador={true}
                            maxlength={255}
                        />
                    </Grid>
                    <Grid display={"flex"} justifyContent={"end"}>
                        <Button
                            onClick={onClickButton}
                            disabled={ texto.length < 5 }
                            color="one_primary"
                            variant="contained"
                            sx={{ marginTop: '3em' }}
                        >Ativar manter aberto</Button>
                    </Grid>
                </Grid>
            </Grid>
        </OneModal>
    )
}
export default ModalObservacao
